const CSS_HEX_COLOR = /^#([0-9a-f]{6})$/i;

export function resolveSlotCreativeTheme({ publisherTheme, backgroundColor } = {}) {
  const background = CSS_HEX_COLOR.exec(String(backgroundColor || "").trim());
  if (!background) return null;

  const result = { background: background[1].toLowerCase() };
  if (!publisherTheme) return result;

  const primary = String(publisherTheme.primary || "").trim();
  const accent = String(publisherTheme.accent || "").trim();
  if (!/^[0-9a-f]{6}$/i.test(primary) || !/^[0-9a-f]{6}$/i.test(accent)) return null;
  return {
    primary: primary.toLowerCase(),
    accent: accent.toLowerCase(),
    background: result.background,
  };
}
